import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./EntertainmentEventsInfo.css"; // Reuse the same styles
import entertainmentImg from '../../assets/serv-3.jpg'; // Replace with your actual image path

const EntertainmentEventsInfo = () => {
  return (
    <section className="info">
      <Container className="company-info">
        <Row>
          <Col md={8} className="slide-in-left">
            <h1 className="text-primary2 fw-bold mb-4">VENUE MANAGEMENT</h1>
           <Row className="align-items-center">
  <Col xs={12} md={6}>
    <img
      src={entertainmentImg}
      alt="Entertainment Events"
      className="img-fluid mb-3 company-image"
    />
  </Col>
  <Col xs={12} md={6} className="text-white">
    <h4 className="mt-4 mb-3">VENUE MANAGEMENT</h4>
    <ul className="event-services-list">
      <li>Concerts</li>
      <li>Music Festivals</li>
      <li>Comedy Shows</li>
      <li>Award Ceremonies</li>
      <li>Talent Shows</li>
      <li>Fashion Shows</li>
    </ul>
  </Col>
</Row>

            <p className="text-white">
             Zarinova Entertainment is the ultimate destination for exceptional entertainment events. Our company is renowned for producing dynamic and captivating experiences that leave audiences spellbound. Whether you’re organizing a concert, theater production, festival, or corporate entertainment, Zarinova Entertainment is committed to delivering top-notch performances and unforgettable moments. Our talented team of event planners, producers, and technical experts work tirelessly to ensure that every aspect of your event exceeds expectations.
            </p>
          </Col>

          <Col md={4} className="slide-in-right">
            <Card className="get-in-touch-card mt-4">
              <Card.Body>
                <h5 className="fw-bold text-white">GET IN TOUCH</h5>
                <p className="small text-white">PLEASE FILL THE FORM FOR ANY QUERY OR SUGGESTION</p>
                <Form>
                  <Form.Group className="mb-3" controlId="formFullName">
                    <Form.Control type="text" placeholder="FULL NAME" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Control type="email" placeholder="EMAIL ADDRESS" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formComment">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="YOUR COMMENT"
                    />
                  </Form.Group>

                  <Button variant="warning1" className="learn-more-btn rounded-pill px-4 py-2 text-white" type="submit">
                    SUBMIT
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EntertainmentEventsInfo;
